export interface IFile {
  file: string
  fileFileName: string
  uuid: string
}

export enum SHIPPER_TYPE {
  new = 'new',
  existing = 'existing',
}

export enum RFP_TYPE {
  rfp = 'rfp',
  reprice = 'reprice',
  dataAnalysis = 'data_analysis',
  shipperRateIndex = 'shipper_rate_index',
}

export interface IShipperApplication {
  id: number
  name: string
}
